/**
 * Formate un nom complet en version courte (Prénom N.)
 * @param {string} fullName - Le nom complet
 * @returns {string} Le nom formaté
 */
export const formatShortName = (fullName) => {
    if (!fullName) return '';
    const parts = fullName.split(' ');
    if (parts.length === 1) return parts[0];
    return `${parts[0]} ${parts[parts.length - 1][0]}.`;
};

/**
 * Retourne les informations de priorité d'un message (icône, label, couleurs)
 * @param {string} priority - La priorité du message ('critique', 'haute', 'moyenne', 'basse', 'minimale')
 * @returns {Object} Objet contenant icon, label, bgColor, textColor, borderColor, title
 */
export const getPriorityInfo = (priority = 'moyenne') => {
    switch (priority) {
        case 'critique':
            return { 
                icon: '»»', 
                label: 'Critique',
                bgColor: 'bg-red-200 dark:bg-red-950',
                textColor: 'text-red-900 dark:text-red-200',
                borderColor: 'border-red-500 dark:border-red-500',
                title: 'Priorité critique (urgente)' 
            };
        case 'haute':
            return { 
                icon: '»', 
                label: 'Haute',
                bgColor: 'bg-orange-100 dark:bg-orange-900/40',
                textColor: 'text-orange-800 dark:text-orange-300',
                borderColor: 'border-orange-400 dark:border-orange-600',
                title: 'Priorité haute' 
            };
        case 'basse':
            return { 
                icon: '=', 
                label: 'Basse',
                bgColor: 'bg-cyan-100 dark:bg-cyan-900/30',
                textColor: 'text-cyan-700 dark:text-cyan-300',
                borderColor: 'border-cyan-300 dark:border-cyan-600',
                title: 'Priorité basse' 
            };
        case 'minimale':
            return { 
                icon: '−', 
                label: 'Minimale',
                bgColor: 'bg-gray-100 dark:bg-gray-800',
                textColor: 'text-gray-600 dark:text-gray-400',
                borderColor: 'border-gray-300 dark:border-gray-600',
                title: 'Priorité minimale' 
            };
        case 'moyenne':
        default:
            return { 
                icon: '›', 
                label: 'Moyenne',
                bgColor: 'bg-blue-100 dark:bg-blue-900/30',
                textColor: 'text-blue-700 dark:text-blue-300',
                borderColor: 'border-blue-300 dark:border-blue-700',
                title: 'Priorité moyenne' 
            };
    }
};

/**
 * Génère le texte d'auteur avec la date de dernière modification
 * @param {Object} message - L'objet message contenant updatedByName, createdByName, updatedAt, createdAt
 * @returns {string} Le texte formaté (ex: "Jean D. • 13/01/2026")
 */
export const getAuthorText = (message) => {
    const authorName = message.updatedByName || message.createdByName;
    const shortName = formatShortName(authorName);
    const date = new Date(message.updatedAt || message.createdAt).toLocaleDateString('fr-FR');
    return `${shortName} • ${date}`;
};
